export default {
    NAME:'Document Name',
    UPLOAD:'Upload'
}